---
type: guest
cover: 'https://media.codingcat.dev/image/upload/main-codingcatdev-photo/podcast-guest/chantastic'
name: Michael Chan
published: published
slug: michael-chan
start: January 1, 2000
picks: https://www.notion.so/Shape-up-e51c9138836445c3a49bc029ee03f7ee
socials:
  github: https://github.com/chantastic
  discord: 'http://discord.gg/lunchdev'
  twitter: 'https://twitter.com/chantastic'
  youtube: 'https://www.youtube.com/c/chantastic'
websites:
  - https://reactpodcast.com/
---

## About

Content creation for devs. Teaching [@storybookjs](https://twitter.com/storybookjs) and [@reactj](https://twitter.com/reactjs).
